var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMo = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M10.875 2.813h-3.75a4.312 4.312 0 1 0 0 8.625h3.75a4.313 4.313 0 0 0 0-8.625Zm5.625 4.5H15M3.563 16.105v-1.918a.5.5 0 0 1 .5-.5h9.875a.5.5 0 0 1 .5.5v1.918m-7.875-4.48V13.5m4.875-1.875V13.5M6.563 5.25V7.5m4.875-2.25V7.5M9 1.15v1.875M3 7.313H1.5m6 1.875h3" }) }))); };
export default SvgMo;
